import { COGNITO_CLIENT_ID } from '../../constants/cognito';
import { getCognitoDomain } from '../../helpers/urls';

export const getTokenUrl = (grantType: 'refresh_token' | 'authorization_code'): string =>
  `${getCognitoDomain()}/oauth2/token?client_id=${COGNITO_CLIENT_ID}&grant_type=${grantType}`;
